import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { REVIEW_MANAGE_GRID_COLUMN_ID } from '../reviewMangeGridConstants';

export const hideReviewManageColumn = ({ displayName, colId, orgId, firstTimePinned, tableColumnsToSelect }) => {
  const intentHasColumnsToSelect = tableColumnsToSelect && tableColumnsToSelect?.length > 0;
  // special case for GROWW: org id 2011
  // need to hide
  if ((colId === '6' || colId === REVIEW_MANAGE_GRID_COLUMN_ID.OVERALL_RATING) && orgId === '2011') {
    return true;
    // eslint-disable-next-line no-else-return
  } else if (checkIntentLandingPagesFeatureEnabled() && intentHasColumnsToSelect) {
    return !(tableColumnsToSelect.includes(displayName) || tableColumnsToSelect.includes(colId));
  } else {
    return !firstTimePinned;
  }
};

export const lockVisibleReviewManageColumn = ({ displayName, tableColumnsLockVisible, columnId = '' }) => {
  const intentHasColumnsToSelect = tableColumnsLockVisible && tableColumnsLockVisible?.length > 0;

  if (intentHasColumnsToSelect && checkIntentLandingPagesFeatureEnabled()) {
    return tableColumnsLockVisible.includes(displayName) || tableColumnsLockVisible.includes(columnId);
  }
  return false;
};
